import { ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { TextPage } from '../../TextPage/TextPage';
import './ModalTableActions.scss'

const ModalTableActions = ({
    products,
    btns
}) => {

    return (
        <div className='modal-table-actions'>
            <TextPage
                text={<>Выбрано: <span
                    style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: 'rgb(34, 197, 94)'
                    }}

                >{products?.length}</span></>}
            />

            <div className='modal-table-actions__btns'>
                {btns.map(({ label, onClick, color }) => {
                    return <ButtonBasic
                        grey={!color || color == 'grey'}
                        blue={color == 'blue'}
                        red={color == 'red'}
                        text={label}
                        width='auto'
                        onClick={onClick}
                    />
                })}
            </div>
        </div>
    )
}

export { ModalTableActions }